import { useCallback } from 'react';
import { Link } from 'react-router-dom';

import { ExternalLink } from 'lucide-react';
import { DefaultTooltip } from 'twyne-new.ui';

import { getInfo } from '@/components/Grid/components/Table/formatters';
import appStore from 'stores/app';

export default function LinkEntity({ info, asLabel }) {
  const { row } = getInfo(info)

  const handleClick = useCallback(() => {
    const url = new URL(`https://${appStore.site.domain}${row.route?.path}`)
    if (process.env.NODE_ENV === 'development') {
      url.port = 3002
      url.protocol = 'http'
    }

    window.open(url.toString(), '_blank')
  }, [row])

  if (asLabel) {
    return <Link onClick={handleClick}>
      Go to site
    </Link>
  }

  return <DefaultTooltip content='View on site'>
    <Link onClick={handleClick}>
      <ExternalLink size={16} />
    </Link>
  </DefaultTooltip>
}
